import DataProvider from '../utils/provider'
import {
  BUSINESS_POSITIONS_API_PATH,
  BUSINESS_TYPES_API_PATH,
  COUNTRIES_API_PATH,
  CURRENCIES_API_PATH,
  EMPLOYMENT_API_PATH,
  FUNDS_API_PATH,
  MOBILE_VERIFICATION_SEND_CODE,
  NETWORTH_INCOMES_API_PATH,
  PRICING_TIERS_API_PATH,
  QUESTIONNAIRE_API_PATH,
  CONFIRM_EMAIL_API_PATH,
  ANNUAL_INCOMES_API_PATH,
  DEPOSIT_AMMOUNTS_API_PATH,
  ACCOUNT_OPEN_REASONS_API_PATH,
  PORTFOLIO_EUR_VALUES_API_PATH,
  EDUCATION_LEVELS_API_PATH,
  PERSON_TITLES_API_PATH,
  TRANSACTION_FREQUENCIES_API_PATH,
  REQUEST_TIER_THREE_API_PATH,
  PAMM_FUND_API_PATH,
  PAMM_REGISTRATION_CHECK,
  RESEND_TOKEN_API_PATH,
  CHECK_LOGIN,
  VERIFY_API_PATH,
  ADD_ACCOUNT_DATA,
  QUESTIONNAIRE_CHECK,
  TRY_REGISTER_LATER_USER,
  PAMM_DEPOSIT_CURRENCIES_API_PATH,
  PAMM_PRICING_TIERS_API_PATH,
  DISTR_TYPES_API_PATH,
  CREATE_PAMM_FUND_API_PATH,
  WEALTH_SOURCE_API_PATH,
  PROCESS_PROMOTIONAL_API_PATH,
  COB_COUNTRIES_API_PATH,
  CITIZENSHIP_COUNTRIES_API_PATH,
  COMMISSION_TYPES_API_PATH,
  COMMISSION_UNITS_API_PATH,
  PEP_STATUSES_API_PATH,
  REMOVE_EXT_DOC_API_PATH,
  GET_USER_UPLOADED_DOCS,
  GET_USER_UPLOADED_DOC_BY_ID,
  PLATFORMS_API_PATH, HEDGE_TRADING_API_PATH
} from '../constants/routes'
import { isNil } from 'ramda'

const queryToSearchParams = (query) => {
  if (!Array.isArray(query) && typeof query === 'object') {
    return new URLSearchParams(
      Object.keys(query).reduce((acc, key) => {
        const val = query[key]
        if (val != null && val !== '') {
          acc[key] = val.toString()
        }
        return acc
      }, {})
    ).toString()
  }
  return new URLSearchParams(query).toString()
}

const withQueryParams = (url, query) => `${url}?${queryToSearchParams(query)}`

export const fetchCountries = () => DataProvider.get(COUNTRIES_API_PATH)

export const fetchCobCountries = () => DataProvider.get(COB_COUNTRIES_API_PATH)

export const fetchCitizenshipCountries = () => DataProvider.get(CITIZENSHIP_COUNTRIES_API_PATH)

export const fetchCurrencies = (paramsObj) =>
  DataProvider.get(withQueryParams(CURRENCIES_API_PATH, paramsObj))

export const fetchPammDepositCurrencies = (paramsObj) =>
  DataProvider.get(withQueryParams(PAMM_DEPOSIT_CURRENCIES_API_PATH, paramsObj))

export const fetchClientTiers = (paramsObj) =>
  DataProvider.get(withQueryParams(PRICING_TIERS_API_PATH, paramsObj))

export const fetchPammClientTiers = (paramsObj) =>
  DataProvider.get(withQueryParams(PAMM_PRICING_TIERS_API_PATH, paramsObj))

export const fetchEmployment = () => DataProvider.get(EMPLOYMENT_API_PATH)

export const fetchFunds = () => DataProvider.get(FUNDS_API_PATH)

export const fetchNetworth = () => DataProvider.get(NETWORTH_INCOMES_API_PATH)

export const sendVerificationCode = (countryCode, phoneNumber) => DataProvider.get(withQueryParams(MOBILE_VERIFICATION_SEND_CODE, { phoneNumber: `${countryCode}${phoneNumber}` }))

export const fetchTypesOfBusiness = () =>
  DataProvider.get(BUSINESS_TYPES_API_PATH)

export const fetchEmploymentPositions = (businessTypeId) =>
  DataProvider.get(withQueryParams(BUSINESS_POSITIONS_API_PATH, { businessTypeId }))

export const fetchQuestionnaireData = () => DataProvider.get(QUESTIONNAIRE_API_PATH)

export const fetchAnnualIncome = () => DataProvider.get(ANNUAL_INCOMES_API_PATH)

export const fetchDepositPerAnnum = () => DataProvider.get(DEPOSIT_AMMOUNTS_API_PATH)

export const fetchPurposeAccountOpen = () => DataProvider.get(ACCOUNT_OPEN_REASONS_API_PATH)

export const fetchPortfolioSize = () => DataProvider.get(PORTFOLIO_EUR_VALUES_API_PATH)

export const fetchHighestLevelEducation = () => DataProvider.get(EDUCATION_LEVELS_API_PATH)

export const fetchPersonTitle = () => DataProvider.get(PERSON_TITLES_API_PATH)

export const fetchTransactionFrequenciesSize = () => DataProvider.get(TRANSACTION_FREQUENCIES_API_PATH)

const accountType = [
  { id: 1400, value: 'Individual', sortOrder: 1 },
  { id: 1401, value: 'Joint', sortOrder: 0 }
]

export const fetchAccountType = () => Promise.resolve(accountType)

const feePeriods = ['M', 'Q', 'Y']

export const fetchFeePeriod = () => Promise.resolve(feePeriods)

export const fetchDistributionTypes = () => DataProvider.get(DISTR_TYPES_API_PATH)

export const isMobile = () => Math.max(window.screen.height, window.screen.width) <= 1024

export const confirmEmail = (token, notificationToken = null) =>
  !isNil(notificationToken) ? DataProvider.get(withQueryParams(CONFIRM_EMAIL_API_PATH, {
    token,
    notificationToken
  })) : DataProvider.get(withQueryParams(CONFIRM_EMAIL_API_PATH, { token }))

export const getUserDetails = (url) => DataProvider.get(url)

export const getUserUploadedDocs = () => DataProvider.get(GET_USER_UPLOADED_DOCS)

export const getUserUploadedDocById = (documentId) => DataProvider.getImage(withQueryParams(GET_USER_UPLOADED_DOC_BY_ID, { documentId }))

export const registerTier3 = (formData) => DataProvider.post(REQUEST_TIER_THREE_API_PATH, formData)

export const getFundName = (fundId) => DataProvider.get(withQueryParams(PAMM_FUND_API_PATH, { fundId }))

export const checkPammRegistration = (email, fundId) => DataProvider.get(withQueryParams(PAMM_REGISTRATION_CHECK, { email, fundId }))

export const postRegisterData = (url, data) => DataProvider.post(url, data)

export const checkLogin = (login, dateOfBirth = '') => DataProvider.get(withQueryParams(CHECK_LOGIN, { login, dateOfBirth }))

export const verifyAccounts = () => DataProvider.post(VERIFY_API_PATH)

export const addAccount = (formData) => DataProvider.postMultipart(ADD_ACCOUNT_DATA, formData)

export const resendTokenApi = (email) => DataProvider.post(RESEND_TOKEN_API_PATH, { email })

export const questionnaireCheck = (data) => DataProvider.post(QUESTIONNAIRE_CHECK, data)

export const tryLater = (data, url = TRY_REGISTER_LATER_USER) => DataProvider.post(url, data)

export const createPammFund = (data) => DataProvider.post(CREATE_PAMM_FUND_API_PATH, data)

export const fetchWealthSource = () => DataProvider.get(WEALTH_SOURCE_API_PATH)

export const processPromotional = (promotionalCode) => DataProvider.post(PROCESS_PROMOTIONAL_API_PATH, { promotionalCode })

export const fetchCommissionTypes = () => DataProvider.get(COMMISSION_TYPES_API_PATH)

export const fetchCommissionUnits = () => DataProvider.get(COMMISSION_UNITS_API_PATH)

export const fetchPepStatuses = () => DataProvider.get(PEP_STATUSES_API_PATH)

export const removeUploadedDocument = (documentId) => DataProvider.delete(withQueryParams(REMOVE_EXT_DOC_API_PATH, { documentId }))

export const fetchPlatforms = (paramsObj) =>
  DataProvider.get(withQueryParams(PLATFORMS_API_PATH, paramsObj))

export const fetchHedgeTrading = (paramsObj) =>
  DataProvider.get(withQueryParams(HEDGE_TRADING_API_PATH, paramsObj))
